import type { AiOptions, MediaQuality } from '@mtm/conversation-client-sdk-annotation';

export type AnnotationPrivateCondition = 'ALL' | 'COMPANY' | 'DOMAIN' | null;

/** Re-exported from `@mtm/conversation-client-sdk-annotation` for app-wide imports via `../../interfaces`. */
export type { AiOptions };
export type { MediaQuality };

/** Builds {@link AiOptions} from annotation send-message event payloads. */
export function aiParamsFromAnnotationEvent(data: {
  agentVersionId?: string | null;
  mediaQuality?: MediaQuality | null;
}): AiOptions {
  return {
    agentVersionId: data.agentVersionId,
    mediaQuality: data.mediaQuality ?? null,
  };
}

export const AnnotationSelectThread = 'annotation.selectThread';
export const AnnotationReplyMessage = 'annotation.replyMessage';
export const AnnotationSendVideoMessage = 'annotation.sendVideoMessage';
export const AnnotationSendImageMessage = 'annotation.sendImageMessage';
export const AnnotationSendMediaMessage = 'annotation.sendMediaMessage';
export const AnnotationSendAudioMessage = 'annotation.sendAudioMessage';
export const AnnotationSendOtherTypesMessage = 'annotation.sendOtherTypesMessage';
export const AnnotationDeleteMessage = 'annotation.deleteMessage';
export const AnnotationEditMessage = 'annotation.editMessage';
export const AnnotationUpdateEditMessage = 'annotation.updateEditMessage';
export const AnnotationCopyLink = 'annotation.copyLink';
export const AnnotationDeleteCommentFile = 'annotation.deleteCommentFile';
export const AnnotationHighlightSelectedAnnotation = 'annotation.highlightSelectedAnnotation';
export const AnnotationSelectThreadNew = 'annotation.selectThreadNew';
